// 消息
export default [{ // 消息列表
  path: '/notificationList',
  name: 'notificationList',
  component: resolve => require(['@/views/notification/notificationList.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 消息详情
  path: '/notificationDetails',
  name: 'notificationDetails',
  component: resolve => require(['@/views/notification/notificationDetails.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/notification/notification.js